import { Flex, Typography } from '@iheartjane/reefer';

export const ExpiredLinkScreen = () => {
  return (
    <Flex
      flexDirection="column"
      gap={16}
      alignItems="center"
      justifyContent="center"
      p={24}
      height="100vh"
      width="100vw"
    >
      <Typography variant="h2-semibold" textAlign="center">
        This link has expired
      </Typography>
      <Typography textAlign="center">
        Return to the kiosk to continue shopping.
      </Typography>
    </Flex>
  );
};
